<template>
    <div id="kt_toolbar_container" class="container-fluid d-flex flex-stack flex-wrap gap-3">
        <!--begin::Page title-->
        <div data-kt-swapper="true" data-kt-swapper-mode="prepend"
            data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
            class="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
            <!--begin::Title-->
            <h1 class="d-flex text-dark fw-bolder fs-3 align-items-center my-1">{{ $t(title) }}</h1>
            <!--end::Title-->
            <!--begin::Separator-->
            <span class="h-20px border-gray-300 border-start mx-4"></span>
            <!--end::Separator-->
            <!--begin::Breadcrumb-->

            <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1 " v-for="(bread, key) in breadcrumbs"
                :key="key">

                <li v-if="key + 1 !== breadcrumbs.length" class="breadcrumb-item text-muted">
                    <router-link :to="bread.path" class="text-muted text-hover-primary">{{ $t(bread.name) }}</router-link>
                    <span class="bullet bg-gray-200 w-5px h-2px m-2"></span>
                </li>


                <!--end::Item-->
                <!--begin::Item-->
                <li v-else class="breadcrumb-item text-dark">{{ $t(bread.name) }}</li>
                <!--end::Item-->
            </ul>
            <!--end::Breadcrumb-->
        </div>
        <!--end::Page title-->
        <!--begin::Actions-->
        <div class="d-flex align-items-center flex-wrap gap-2 gap-lg-3 contacts-toolbar-actions">
          <div class="d-flex align-items-center position-relative my-1 contacts-toolbar-search">
              <!--begin::Svg Icon | path: icons/duotune/general/gen021.svg-->
              <span class="svg-icon svg-icon-1 position-absolute ms-6">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1"
                          transform="rotate(45 17.0365 15.1223)" fill="currentColor" />
                      <path
                          d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z"
                          fill="currentColor" />
                  </svg>
              </span>
              <!--end::Svg Icon-->
              <input type="text" v-model="$parent.search" data-allow-clear="true"
                  class="form-control form-control-sm form-control-solid w-100 w-md-250px h-35px ps-15"
                  :placeholder="$t('contacts.placeholder.search')" />
          </div>
          <button class="btn btn-sm btn-flex btn-light-primary btn-active-primary fw-bolder"
                  :class="filtered ? 'active' : ''"
                  data-kt-menu-trigger="hover"
                  data-kt-menu-attach="parent"
                  data-kt-menu-placement="bottom-end">
                <span class="svg-icon svg-icon-5 svg-icon-gray-500 me-1">
                    <i class="fa fa-filter"></i>
                </span>
            {{ $t('button.filter') }}
          </button>
          <div id="filterDropdown" class="menu menu-sub menu-sub-dropdown menu-column w-250px w-md-300px" data-kt-menu="true">
            <div class="menu-item px-3 py-5">
              <div class="menu-content fs-6 text-gray-900 fw-bold">
                {{ $t('button.filter') }}
              </div>
            </div>
            <div class="separator border-gray-200 mb-3 opacity-75"></div>
            <div class="px-7 py-5">
              <Select2
                  parent-id="#filterDropdown"
                  containerClass="mb-10"
                  name="filterContactByCat"
                  :multiple="false"
                  :label="$t('label.contactCategory')"
                  labelClass="text-black fw-bold"
                  selectClass="form-select form-select-solid"
                  :isRequired="false"
                  :showSearch="false"
                  :placeholderText="$t('contacts.placeholder.city')"
                  v-model="filter.category">
                <option v-for="filter in filterBy" :value="filter.value" :key="filter.value">
                  {{ $t(filter.translate) }}
                </option>
              </Select2>
              <Select2
                  parent-id="#filterDropdown"
                  containerClass="mb-10"
                  name="filterContactByType"
                  :multiple="false"
                  :label="$t('label.contactType')"
                  labelClass="text-black fw-bold"
                  selectClass="form-select form-select-solid"
                  :isRequired="false"
                  :showSearch="false"
                  :placeholderText="$t('contacts.placeholder.city')"
                  v-model="filter.type">
                <option v-for="filter in filterByType" :value="filter.value" :key="filter.value">
                  {{ $t(filter.translate) }}
                </option>
              </Select2>
              <div class="d-flex justify-content-end">
                <button type="reset"
                        @click.prevent="resetFilter"
                        class="btn btn-sm btn-light btn-active-light-primary me-2"
                        data-kt-menu-dismiss="true">
                  {{ $t('button.reset') }}
                </button>
                <button type="submit"
                        @click.prevent="applyFilter"
                        class="btn btn-sm btn-primary"
                        data-kt-menu-dismiss="true">
                  {{ $t('button.apply') }}
                </button>
              </div>
            </div>
          </div>

          <button v-if="$can('customer_create')" class="btn btn-sm btn-light-primary  my-1" @click="openModalCreateContact">{{ $t('button.add') }}</button>
          <button class="btn btn-sm btn-flex btn-light-primary btn-active-primary fw-bolder" data-bs-toggle="modal"
              data-bs-target="#importContactModal">
              <span class="svg-icon svg-icon-5 svg-icon-gray-500 me-1">
                  <i class="fa fa-file-alt"></i>
              </span>
              Actions
          </button>
        </div>
        <!--end::Actions-->
    </div>
</template>

<script>
import { mapActions } from "vuex";
import Select2 from "@/components/Select2.vue";

export default {
  components: {Select2},
  props: {
    title: {required: true, type: String, default: 'breadcrumbs.contact.contacts'},
    breadcrumbs: {required: false, type: Array, default: []},
    back: {required: false, type: Boolean, default: false},
    filterBy: {required: false, type: Array, default: []},
    filterByType: {required: false, type: Array, default: []},
  },
  data() {
    return {
      isLoading: false,
      filter: {
        category: "all",
        type: "all"
      }
    }
  },
  computed: {
    filtered () {
      return this.$parent.filter !== 'all' ||  this.$parent.contactType !== 'all'
    }
  },
  methods: {
    openCreateModal() {
      $('#createModal').modal('toggle')
    },
    openModalCreateContact() {
      $('#contactCreateModal').modal('toggle')
    },
    applyFilter() {
      this.$parent.filter = this.filter.category
      this.$parent.contactType = this.filter.type
    },
    resetFilter() {
      this.$parent.filter = 'all'
      this.$parent.contactType = 'all'
      this.filter = {
        category: 'all',
        type: 'all'
      }
    }

  }
}
</script>
<style scoped>
#kt_menu_action{
  box-shadow: rgb(0 0 0 / 12%) 0px 1px 4px 1px;
  border-radius: 10px;
  z-index: 105;
  position: fixed;
  inset: 0px 0px auto auto;
  margin: 0px;
  transform: translate(-115px, 110px);
}
/* Mobile : la recherche prend toute la largeur, les boutons passent dessous
   (sur une seule ligne, ils faisaient déborder la page et l'en-tête) */
@media (max-width: 767px) {
  .contacts-toolbar-actions {
    width: 100%;
  }
  .contacts-toolbar-search {
    flex: 1 1 100%;
  }
}
</style>
